export const nav = {
  home: 'Home',
  webHosting: 'Web Hosting',
  gameHosting: 'Server di Gioco',
  vps: 'VPS Hosting',
  dedicated: 'Server Dedicati',
  businessSolutions: 'Soluzioni Business',
  network: 'SynthoNetwork',
  colocation: 'Colocation',
  ipTransit: 'IP Transit',
  contact: 'Contattaci',
  clientArea: 'Area Clienti',
  services: 'Servizi',
  support: 'Supporto',
  faq: 'FAQ',
  abuse: 'Segnala Abuso'
};